import React, { useEffect, useState } from "react";

const AnimatedNumber = ({ value, duration = 1000, format = true }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;
    const startTime = performance.now();

    const step = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.floor(start + (end - start) * progress);
      setDisplayValue(current);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [value, duration]);

  const formatted = format
    ? displayValue.toLocaleString() // ✅ 會有千位分隔 15,000
    : displayValue;

  return <span>{formatted}</span>;
};

export default AnimatedNumber;
